exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Global CSS for Bulk Purchase */\n.bulk-purchase .request-builds-btn {\n  background-color: #51007A;\n  color: var(--white);\n  letter-spacing: 0;\n}\n.bulk-purchase .request-builds-btn:hover {\n  background-color: transparent;\n  color: #51007A;\n  border-color: #51007A;\n}", ""]);

// exports
